import React, { memo } from 'react'
import ReactTooltip from 'react-tooltip';

export default memo(function Tooltip(props) {
    return (
        <ReactTooltip border={false} key={props.id} id={props.id} effect='float' delayHide={100} delayShow={100} delayUpdate={100} place='right' type="info" {...props}>
            {props.children}
        </ReactTooltip>
    )
})